import { useTranslation } from "react-i18next";
import { PageHeader, SectionHeader, PrimaryLink } from "../components/ui-blocks";
import WorldMap from "../components/WorldMap";

export default function Impact() {
  const { t } = useTranslation();
  const pillars = t("data.pillars", { returnObjects: true });

  return (
    <>
      <PageHeader
        testId="impact-header"
        overline={t("impact.headerOverline")}
        title={t("impact.headerTitle")}
        lead={t("impact.headerLead")}
      />

      <section className="section-pad" data-testid="impact-presence">
        <div className="container-mtbl">
          <div className="grid lg:grid-cols-12 gap-10 items-end mb-14">
            <div className="lg:col-span-7">
              <SectionHeader
                overline={t("impact.presenceOverline")}
                title={t("impact.presenceTitle")}
                lead={t("impact.presenceLead")}
              />
            </div>
          </div>
          <WorldMap />
        </div>
      </section>

      <section
        className="section-pad bg-paper border-t border-slate-200"
        data-testid="impact-pillars"
      >
        <div className="container-mtbl">
          <SectionHeader
            overline={t("impact.pillarsOverline")}
            title={t("impact.pillarsTitle")}
          />
          <div className="mt-14 grid md:grid-cols-3 gap-6">
            {pillars.map((p, i) => (
              <div
                key={p.title}
                data-testid={`impact-pillar-${i}`}
                className="card-soft p-10"
              >
                <p className="overline">0{i + 1}</p>
                <h3 className="mt-4 text-[#0B1A3D] text-xl md:text-2xl font-semibold tracking-tight">
                  {p.title}
                </h3>
                <p className="mt-4 text-slate-600 leading-relaxed">{p.body}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section data-testid="impact-csr" className="section-pad">
        <div className="container-mtbl grid lg:grid-cols-12 gap-14">
          <div className="lg:col-span-5">
            <p className="overline mb-4">{t("impact.csrOverline")}</p>
            <h2 className="text-[#0B1A3D] text-3xl md:text-4xl lg:text-5xl font-semibold tracking-tight leading-tight">
              {t("impact.csrTitle")}
            </h2>
          </div>
          <div className="lg:col-span-7 space-y-5 text-slate-600 text-base md:text-lg leading-relaxed">
            <p>{t("impact.csrP1")}</p>
            <p>{t("impact.csrP2")}</p>
          </div>
        </div>
      </section>

      <section
        data-testid="impact-cta"
        className="bg-paper border-t border-slate-200"
      >
        <div className="container-mtbl py-20 md:py-24 flex flex-col md:flex-row items-start md:items-center justify-between gap-8">
          <h3 className="text-[#0B1A3D] text-2xl md:text-3xl lg:text-4xl font-semibold tracking-tight max-w-2xl">
            {t("impact.ctaTitle")}
          </h3>
          <PrimaryLink to="/partnerships" testId="impact-cta-partnerships">
            {t("nav.partnerships")}
          </PrimaryLink>
        </div>
      </section>
    </>
  );
}
